module.exports = __webpack_public_path__ + "img/mid-active2.563cd46b.jpg";